import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnlineTaskInspectionDetailComponent } from './online-task-inspection-detail.component';

const routes: Routes = [
  { path: '', component: OnlineTaskInspectionDetailComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OnlineTaskInspectionDetailRoutingModule {}
